import React, { useState, useEffect, useRef } from "react";
import Header from "./Header";
import User2 from "../img/User2.svg";
import User1 from "../img/User1.svg";
import RightPurple from "../img/RightPurple.svg";
import Setting_line from "../img/Setting_line.svg";
import SettingLog from "../img/SettingLog.svg";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Edit_fill from "../img/Edit_fill.svg";
import Trash from "../img/Trash.svg";
import Close_roundClose from "../img/Close_roundClose.svg";
import BackgroundImg from "../img/BackgroundNetImg.svg";
import { Link } from "react-router-dom";
import axios from "axios";
import api from "../../api/axiosInstance";
import CustomLoader from "./CustomLoader";

const SettingsPage = () => {
  const location = useLocation();
  const passwordLastChanged = location.state?.passwordLastChanged;
  const [activeTab, setActiveTab] = useState("settings"); // ✅ Default to "settings"
  const navigate = useNavigate(); // ✅ Setup navigate
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false); // Modal state for "Add a new address"
  const [userCountry, setUserCountry] = useState("");
  const [userCountryCode, setUserCountryCode] = useState("");
  const [postalCode, setPostalCode] = useState(""); // Postal code input state
  const [city, setCity] = useState(""); // City state
  const [district, setDistrict] = useState(""); // District state
  const [state, setState] = useState(""); // State state
  const [country, setCountry] = useState(""); // Country state
  const [gstNo, setGstNo] = useState(""); // GST number state
  const [address, setAddress] = useState(""); // Address input
  const [latitude, setLatitude] = useState(""); // Latitude input
  const [longitude, setLongitude] = useState(""); // Longitude input
  const [licenseNumber, setLicenseNumber] = useState(""); // License Number
  const [addresses, setAddresses] = useState([]); // To store the addresses
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] =
    useState(false);
  const [addressToDelete, setAddressToDelete] = useState(null); // Store address to delete
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState(""); // State for the modal message
  const [modalType, setModalType] = useState(""); // State for the modal type (success or error)
  const [locations, setLocations] = useState([]);
  const [isFromKerala, setIsFromKerala] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [showPostalModal, setShowPostalModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isDefaultDeleteModalOpen, setIsDefaultDeleteModalOpen] =
    useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const sidebarRef = useRef(null);
  const [emailToggle, setEmailToggle] = useState(null);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [modalAnimation, setModalAnimation] = useState("");
  const [logoutModalAnimation, setLogoutModalAnimation] = useState("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSidebarOpen(false);
      }
    };

    if (sidebarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarOpen]);

  useEffect(() => {
    fetchUserCountry(); // Call the function when the component loads
    fetchAddresses();
  }, []);

  const toggleAddressModal = () => {
    setIsAddressModalOpen(!isAddressModalOpen);
    setAddress("");
    setCity("");
    setCountry("");
    setDistrict("");
    setGstNo("");
    setPostalCode("");
    setState("");
    setErrors({});
  };

  const handleEditAddress = (addressId) => {
    const addressToEdit = addresses.find((address) => address.id === addressId); // Find the address by ID
    setSelectedAddress(addressToEdit); // Set the address data to the modal state
    // setIsModalOpen(true); // Open the modal
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handlePostalCodeChange = async (e) => {
    const enteredPostalCode = e.target.value;
    setPostalCode(enteredPostalCode);

    if (enteredPostalCode) {
      try {
        const response = await axios.get(
          `https://api.worldpostallocations.com/pincode?postalcode=${enteredPostalCode}&countrycode=IN`
        );

        const postalLocations = response.data.result || [];

        const foundKerala = postalLocations.some(
          (location) => location.state.toLowerCase() === "kerala"
        );
        setIsFromKerala(foundKerala);
        setLocations(postalLocations);
        setShowPostalModal(true); // Show postal locations modal when results are available
      } catch (error) {
        console.error("Error fetching postal data:", error);
      }
    } else {
      setShowPostalModal(false); // Hide postal locations modal if postal code is empty
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close modal
    setSelectedAddress(null); // Reset selected address
    setErrors({});
  };

  const handleLocationSelection = (location) => {
    setSelectedLocation(location); // Update selected location with the details
  };

  const handleModalClose = () => {
    setShowPostalModal(false);
  };

  const handleConfirmLocation = () => {
    if (selectedLocation) {
      // If we're editing an address
      if (isEditModalOpen && selectedAddress) {
        setCity(selectedLocation.postalLocation); // Use postal location for city
        setDistrict(selectedLocation.district); // Use selected district
        setState(selectedLocation.state); // Use selected state
        setCountry(selectedLocation.country); // Use selected country
        setPostalCode(selectedLocation.postalCode); // Use postal code

        // Close the postal location modal and open the edit address modal
        setShowPostalModal(false);
        setIsEditModalOpen(true); // Open the edit modal
      } else {
        // If we're adding a new address
        setCity(selectedLocation.postalLocation); // Use postal location for city
        setDistrict(selectedLocation.district); // Use selected district
        setState(selectedLocation.state); // Use selected state
        setCountry(selectedLocation.country); // Use selected country
        setPostalCode(selectedLocation.postalCode); // Use postal code

        // Close the postal location modal and open the add address modal
        setShowPostalModal(false);
        setIsAddressModalOpen(true); // Open the add address modal
      }
    }
  };

  const toggleEditModal = () => {
    setIsEditModalOpen(!isEditModalOpen);
  };

  const handleSetDefaultAddress = async (id) => {
    try {
      const token = localStorage.getItem("accessToken"); // Get the token from session storage
      if (!token) {
        console.error("No token found");
        return;
      }

      // Send PATCH request to update the address to default
      const response = await api.patch(
        `/display/api/v1/patch-delete-billing-address/${id}`,
        {
          is_default: true,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        // On successful response, update the address state
        const updatedAddresses = addresses.map(
          (address) =>
            address.id === id
              ? { ...address, is_default: true } // Update the clicked address to default
              : { ...address, is_default: false } // Set the rest to non-default
        );

        // Sort addresses so that default address is first
        const sortedAddresses = updatedAddresses.sort((a, b) => {
          if (a.is_default && !b.is_default) return -1;
          if (!a.is_default && b.is_default) return 1;
          return 0;
        });

        setAddresses(sortedAddresses); // Update state with the sorted addresses
      } else {
        console.error("Failed to update address:", response.data);
      }
    } catch (error) {
      console.error("Error updating address:", error);
    }
  };

  const handleDeleteIconClick = (addressId) => {
    // Find the address object for the given addressId
    const addressToDelete = addresses.find(
      (address) => address.id === addressId
    );

    // Check if the address to delete is default
    if (addressToDelete && addressToDelete.is_default) {
      setIsDefaultDeleteModalOpen(true);
      return;
    }

    // If not the default address, proceed to show the confirmation modal
    setAddressToDelete(addressId); // Set the addressId for deletion
    setIsDeleteConfirmationModalOpen(true); // Open the delete confirmation modal
  };

  const handleLogout = async () => {
    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken) {
      console.log("No refresh token found.");
      return;
    }

    try {
      const response = await api.post("/display/api/v1/logout", {
        refresh_token: refreshToken, // Pass the refresh token
      });

      if (response.status === 200 && response.data.status === "success") {
        // Clear session data
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user_id");
        // Redirect to login page or home page after successful logout
        window.location.href = "/";
      } else {
        console.error("Failed to logout:", response.data.message);
      }
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  const handleDeleteAccount = async () => {
    // Fetch the access token from session storage
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken"); // Fetch the refresh token

    // Check if access token or refresh token exists
    if (!accessToken || !refreshToken) {
      showModal("Please log in first.", "error");
      return;
    }

    try {
      // Call the API to delete the account
      const response = await api.post(
        "/display/api/v1/delete-user", // Full URL of the API
        {
          refresh_token: refreshToken, // Include refresh token in the request body
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`, // Pass the access token in the Authorization header
          },
        }
      );

      // Check if the response is successful
      if (response.status === 200 && response.data.status === "success") {
        // Handle successful deletion
        console.log("Account deleted successfully!");
        showModal("Your account has been deleted successfully.", "success");

        // Clear tokens from localStorage
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");

        // Redirect to the login page after account deletion
        navigate("/"); // Navigate to the login page
      } else {
        // Handle failure
        console.error("Failed to delete account:", response.data.message);
        showModal("Failed to delete the account. Please try again.", "error");
      }
    } catch (error) {
      // Handle errors (e.g., network issues)
      console.error("Error deleting account:", error);
      showModal("Something went wrong. Please try again later.", "error");
    }

    // Close the modal after the API call
    setIsModalOpen(false);
  };

  const showModal = (message, type) => {
    setModalMessage(message); // Set the message for the modal
    setModalType(type); // Set the type of the modal ("success" or "error")
    setIsMessageModalOpen(true); // Open the modal
  };

  const handleSaveAddress = async () => {
    const token = localStorage.getItem("accessToken");

    // validate required fields
    const newErrors = {};

    if (!address.trim()) newErrors.address = "Street is required";
    if (!postalCode.trim()) {
      newErrors.postalCode = "PIN Code is required.";
    } else if (postalCode.length !== 6) {
      newErrors.postalCode = "PIN Code must be 6 digits.";
    }
    if (!city.trim()) newErrors.city = "City is required.";
    if (!district.trim()) newErrors.district = "District is required.";
    if (!state.trim()) newErrors.state = "State is required.";
    if (!country.trim()) newErrors.country = "Country is required.";
    // GST is optional

    setErrors(newErrors);

    // if any errors exist, do not proceed
    if (Object.keys(newErrors).length > 0) {
      return;
    }

    console.log("Save clicked with data:", {
      address_1: address,
      city,
      state,
      pincode: postalCode,
      latitude: latitude || 0,
      longitude: longitude || 0,
      district,
      country,
      license_number: gstNo || "",
      is_from_kerala: isFromKerala,
    });

    try {
      const res = await api.post(
        "/display/api/v1/create-billing-address",
        {
          address_1: address,
          city,
          state,
          pincode: postalCode,
          latitude: latitude || 0,
          longitude: longitude || 0,
          district,
          country,
          license_number: gstNo || "",
          is_from_kerala: isFromKerala,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Billing address created:", res.data);
      fetchAddresses();

      // clear form
      setAddress("");
      setCity("");
      setCountry("");
      setDistrict("");
      setGstNo("");
      setPostalCode("");
      setState("");

      setIsAddressModalOpen(false);
    } catch (err) {
      console.error("Error creating billing address:", err.response || err);
    }
  };

  const fetchAddresses = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken"); // Ensure token is retrieved from session storage
      if (!token) {
        console.error("No token found");
        return;
      }

      const response = await api.get("/display/api/v1/list-billing-address", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200 || response.status === 201) {
        // Sort the addresses so that the default address is first
        const sortedAddresses = response.data.data.sort((a, b) => {
          if (a.is_default && !b.is_default) return -1; // Move default address to the top
          if (!a.is_default && b.is_default) return 1;
          return 0;
        });
        setAddresses(sortedAddresses); // Set the fetched and sorted addresses in state
      } else {
        console.error("Failed to fetch addresses:", response.data);
      }
    } catch (error) {
      console.error("Error fetching addresses:", error);
    } finally {
      setLoading(false); // end loading
    }
  };

  const fetchUserCountry = async () => {
    try {
      // Using ip-api's free service
      const response = await axios.get("http://ip-api.com/json/");
      const country = response.data.country; // Extract country from response
      const countryCode = response.data.countryCode; // Extract country code from response

      setUserCountry(country); // Set the country in the state
      setUserCountryCode(countryCode); // Set the country code in the state

      console.log("User's country:", country); // Log the country to the console
      console.log("User's country code:", countryCode); // Log the country code to the console
    } catch (error) {
      console.error("Error fetching country data:", error); // Handle any errors
    }
  };

  const handleSaveChanges = async () => {
    const token = localStorage.getItem("accessToken"); // Get the token from session storage
    if (!token) {
      console.error("No token found");
      return;
    }

    const newErrors = {};

    if (!selectedAddress.address_1.trim())
      newErrors.address_1 = "Street is required.";
    if (!selectedAddress.pincode?.toString().trim()) {
      newErrors.pincode = "PIN Code is required.";
    }
    if (!selectedAddress.city.trim()) newErrors.city = "City is required.";
    if (!selectedAddress.district.trim())
      newErrors.district = "District is required.";
    if (!selectedAddress.state.trim()) newErrors.state = "State is required.";
    if (!selectedAddress.country.trim())
      newErrors.country = "Country is required.";
    // GST is optional

    setErrors(newErrors);

    // if any errors exist, do not proceed
    if (Object.keys(newErrors).length > 0) {
      return;
    }

    try {
      const requestBody = {
        city: selectedAddress.city,
        address_1: selectedAddress.address_1,
        state: selectedAddress.state,
        pincode: selectedAddress.pincode,
        latitude: selectedAddress.latitude || 0, // Assuming default value of 0 if not provided
        longitude: selectedAddress.longitude || 0, // Assuming default value of 0 if not provided
        district: selectedAddress.district,
        country: selectedAddress.country,
        license_number: selectedAddress.license_number,
        is_default: selectedAddress.is_default,
      };

      const response = await api.patch(
        `/display/api/v1/patch-delete-billing-address/${selectedAddress.id}`, // Dynamic URL with selected address id
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            "Content-Type": "application/json", // Set content type to JSON
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        console.log("Address updated successfully", response.data);

        // Update the address state without needing to reload the page
        const updatedAddresses = addresses.map((address) =>
          address.id === selectedAddress.id
            ? { ...selectedAddress, ...requestBody }
            : address
        );
        setAddresses(updatedAddresses); // Update state with the modified address

        // Close the modal after saving
        handleCloseModal();
      } else {
        console.error("Failed to update address:", response.data);
      }
    } catch (error) {
      console.error("Error updating address:", error);
    }
  };

  const handleDeleteConfirmed = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        console.error("No token found");
        return;
      }

      // Use the addressToDelete ID to get the correct address from the state
      const addressToDeleteObj = addresses.find(
        (address) => address.id === addressToDelete
      );

      if (!addressToDeleteObj) {
        console.error("Address not found");
        return;
      }

      // Proceed to delete the address
      const response = await api.delete(
        `/display/api/v1/patch-delete-billing-address/${addressToDeleteObj.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        console.log("Address deleted successfully");
        // Update the addresses list by removing the deleted address
        setAddresses((prevAddresses) =>
          prevAddresses.filter(
            (address) => address.id !== addressToDeleteObj.id
          )
        );
        setIsDeleteConfirmationModalOpen(false); // Close the modal
      } else {
        console.error("Failed to delete address:", response.data);
      }
    } catch (error) {
      console.error("Error deleting address:", error);
    }
  };

  const openModalWithAnimation = (setModal, setAnimation) => {
    setModal(true);
    setTimeout(() => {
      setAnimation("enter");
    }, 10);
  };

  const closeModalWithAnimation = (setModal, setAnimation) => {
    setAnimation("exit");
    setTimeout(() => {
      setModal(false);
      setAnimation("");
    }, 300);
  };

  if (loading) {
    return <CustomLoader></CustomLoader>;
  }

  return (
    <div>
      <Header></Header>

      {/* Mobile Top Bar with Hamburger */}
      <div className="md:hidden flex justify-between items-center px-4 py-3 bg-white shadow">
        <button
          onClick={() => setSidebarOpen(true)}
          className="text-3xl"
          aria-label="Open sidebar"
        >
          &#9776;
        </button>
      </div>

      <div
        ref={sidebarRef}
        className={`fixed top-0 left-0 h-full w-1/2 bg-white shadow-lg z-50 py-4 overflow-y-auto transition-all duration-500 ease-in-out ${
          sidebarOpen
            ? "translate-x-0 opacity-100"
            : "-translate-x-full opacity-0"
        }`}
      >
        {/* Header inside sidebar */}
        <div className="flex justify-between items-center px-4 py-3 border-b">
          <h2 className="text-lg font-semibold">Menu</h2>
          <button
            onClick={() => setSidebarOpen(false)}
            className="text-3xl font-bold"
          >
            &times;
          </button>
        </div>

        {/* Mobile Sidebar Content */}
        <div className="flex flex-col gap-4">
          {/* Profile Tab */}
          <div
            className={`flex items-center gap-3 cursor-pointer px-3 py-2 rounded ${
              activeTab === "profile" ? "bg-[#F7F2FF]" : ""
            }`}
            onClick={() => {
              setActiveTab("profile");
              navigate("/profile");
              setSidebarOpen(false);
            }}
          >
            <img
              src={activeTab === "profile" ? User2 : User1}
              alt="Profile Icon"
            />
            <span
              className={`${
                activeTab === "profile" ? "text-[#9061DB]" : "text-black"
              }`}
            >
              Profile
            </span>
          </div>

          {/* Settings Tab */}
          <div
            className={`flex items-center gap-3 cursor-pointer px-3 py-2 rounded ${
              activeTab === "settings" ? "bg-[#F7F2FF]" : ""
            }`}
            onClick={() => {
              setActiveTab("settings");
              navigate("/settings");
              setSidebarOpen(false);
            }}
          >
            <img
              src={activeTab === "settings" ? SettingLog : Setting_line}
              alt="Settings Icon"
            />
            <span
              className={`${
                activeTab === "settings" ? "text-[#9061DB]" : "text-black"
              }`}
            >
              Settings
            </span>
          </div>
        </div>
      </div>

      <div
        className="flex flex-col md:flex-row px-4 md:px-10 py-6 w-full fixed"
        style={{
          backgroundImage: `url(${BackgroundImg})`,
          backgroundPosition: "50% 0%",
        }}
      >
        {/* Sidebar */}
        <div className="md:flex hidden gap-2 flex-col w-full md:w-2/12 mb-6 md:mb-0 font-semibold">
          {/* Profile Tab */}
          <div
            className={`flex items-center gap-3 cursor-pointer h-9  rounded hover:bg-[#F7F2FF] ${
              activeTab !== "profile" ? "" : ""
            }`}
            onClick={() => {
              setActiveTab("profile");
              navigate("/profile"); // ✅ Navigate to Profile page
            }}
          >
            <div
              className="w-1 h-5 rounded"
              style={{
                backgroundColor:
                  activeTab === "profile" ? "#9061DB" : "transparent",
              }}
            ></div>
            <img
              src={activeTab === "profile" ? User2 : User1}
              alt="Profile Icon"
            />
            <span
              style={{ color: activeTab === "profile" ? "#9061DB" : "black" }}
            >
              Profile
            </span>
            {activeTab === "profile" && <img src={RightPurple} alt="arrow" />}
          </div>

          {/* Settings Tab */}
          <div
            className="flex items-center gap-3 cursor-pointer h-9  rounded"
            onClick={() => {
              setActiveTab("settings");
              navigate("/settings"); // ✅ Already on settings, but safe for reuse
            }}
          >
            <div
              className="w-1 h-5 rounded"
              style={{
                backgroundColor:
                  activeTab === "settings" ? "#9061DB" : "transparent",
              }}
            ></div>
            <img
              src={activeTab === "settings" ? SettingLog : Setting_line}
              alt="Settings Icon"
            />
            <span
              style={{ color: activeTab === "settings" ? "#9061DB" : "black" }}
            >
              Settings
            </span>
            {activeTab === "settings" && <img src={RightPurple} alt="arrow" />}
          </div>
        </div>

        {/* Separator Line */}
        <div className="hidden md:block w-px bg-gray-300 h-auto" />

        {/* Content */}
        <div className="px-4 md:px-10 w-full md:w-10/12 overflow-y-auto max-h-[calc(100vh-120px)] md:max-h-[calc(100vh-64px)] scrollbar-hide">
          <h1 className="text-2xl mb-2 font-semibold">Settings</h1>

          <h1 className="mt-4 mb-2 text-black text-inter text-xl font-semibold">
            Address
          </h1>

          {addresses.length === 0 && (
            <div
              className="w-full h-[158px] bg-white rounded-lg border border-[#D9D9D9] flex flex-col"
              style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
            >
              {/* Top Half */}

              <div className="w-full h-1/2 bg-[#F7F2FF] border-b border-[#D9D9D9] flex items-center justify-end px-4 rounded-tl-lg rounded-tr-lg">
                {/* <h2 className="text-lg font-inter font-semibold text-gray-800">
                Default Address
              </h2> */}

                <button
                  className="text-white text-sm font-medium px-4 py-2 rounded"
                  style={{
                    background:
                      "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                  }}
                  onClick={toggleAddressModal}
                >
                  Add Address
                </button>
              </div>

              {/* Render Address 1 */}
              {/* {addresses?.length > 0 ? (
              (() => {
                const defaultAddress = addresses.find(
                  (addr) => addr.is_default
                );
                return defaultAddress ? (
                  <div
                    key={defaultAddress.id}
                    className="w-full h-1/2 flex flex-col justify-center px-4"
                  >
                    <h2 className="text-sm font-semibold text-black text-inter">
                      {defaultAddress.address_1}, {defaultAddress.city},{" "}
                      {defaultAddress.state}, {defaultAddress.pincode},{" "}
                      {defaultAddress.district}, {defaultAddress.country}
                    </h2>
                  </div>
                ) : (
                  <p className="text-sm text-gray-600 px-4">
                    You haven't added any address yet.
                  </p>
                );
              })()
            ) : (
              <p className="text-sm text-gray-600 px-4 pt-5">
                You haven't added any address yet.
              </p>
            )} */}

              <span className="text-sm text-gray-600 px-4 pt-5">
                You haven't added any address yet.
              </span>
            </div>
          )}

          <div className="flex flex-wrap gap-4 my-2">
            {
              addresses.length > 0
                ? addresses.map((address, index) => {
                    return (
                      <div
                        key={address.id}
                        className="relative w-full h-[79px] bg-white border border-[#D9D9D9] rounded-md px-4"
                        style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
                      >
                        <span className="block w-full break-words text-sm leading-snug  py-4">
                          {address.address_1}, {address.city},{" "}
                          {address.district},{address.state}, {address.pincode}
                        </span>

                        <div className="absolute top-2 right-2 flex flex-col gap-[2rem] items-center">
                          {/* <div className="relative">
                            <input
                              type="checkbox"
                              checked={address.is_default}
                              onChange={() =>
                                handleSetDefaultAddress(address.id)
                              }
                              style={{
                                appearance: "none",
                                width: "24px",
                                height: "24px",
                                borderRadius: "4px",
                                border: "2px solid #9061DB",
                                backgroundColor: address.is_default
                                  ? "#9061DB"
                                  : "transparent",
                                cursor: "pointer",
                              }}
                            />
                            {address.is_default && (
                              <div
                                style={{
                                  color: "white",
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  position: "absolute",
                                  top: "0px",
                                  right: "6px",
                                }}
                              >
                                ✓
                              </div>
                            )}
                          </div> */}

                          {/* Edit and Delete Icons */}
                          <img
                            src={Edit_fill}
                            alt="Edit"
                            className="w-6 h-6 cursor-pointer hover:scale-125 transition-transform duration-300"
                            onClick={() => handleEditAddress(address.id)}
                          />
                          {/* <img
                            src={Trash}
                            alt="Delete"
                            className="w-6 h-6 cursor-pointer"
                            onClick={() => handleDeleteIconClick(address.id)} // Correctly passing the address.id
                          /> */}
                        </div>
                      </div>
                    );
                  })
                : null
              // (
              //   <p className="text-sm text-gray-600 px-4">You haven't added any address yet.</p>
              // )
            }
          </div>

          <h1 className="mt-4 mb-2 text-black text-inter text-xl font-semibold">
            Account Security
          </h1>

          <div
            className="w-full h-[75px] bg-white rounded-lg border border-[#D9D9D9] flex flex-col"
            style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
          >
            {/* Bottom Half */}
            <div className="w-full  h-full flex  justify-between items-center px-4 py-4">
              <div className="flex flex-col justify-center">
                <div className="flex justify-between">
                  <h2 className="text-lg text-inter font-semibold text-black">
                    Email Notification
                  </h2>
                  <div
                    className="w-12 h-6 sm:hidden  border border-primary rounded-full flex items-center cursor-pointer transition-colors duration-300 ease-in-out"
                    onClick={() => setEmailToggle((prev) => !prev)}
                  >
                    <div
                      className={`w-5 h-5 rounded-full bg-primary transform transition-transform duration-300 ease-in-out ${
                        emailToggle ? "translate-x-6" : "translate-x-1"
                      }`}
                    ></div>
                  </div>
                </div>

                <p className="text-sm text-inter text-black">
                  Receive email alerts whenever your account is signed in from a
                  new device, browser.
                </p>
              </div>

              <div
                className="w-16 h-8 border hidden border-primary rounded-full sm:flex items-center px-1 cursor-pointer   duration-300 ease-in-out"
                onClick={() => setEmailToggle((prev) => !prev)}
              >
                <div
                  className={`w-6 h-6 rounded-full bg-primary transform transition-transform duration-300 ease-in-out ${
                    emailToggle ? "translate-x-8" : "translate-x-0"
                  }`}
                ></div>
              </div>
            </div>
          </div>

          <div
            className="w-full h-[79px] bg-white rounded-lg border border-[#D9D9D9] flex flex-col mt-4"
            style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
          >
            {/* Single Section */}
            <div className="w-full h-full bg-[#F7F2FF] flex items-center justify-between px-4 rounded-lg">
              {/* Text Content */}
              <div>
                <h2 className="text-lg text-inter font-semibold text-black">
                  Change Password
                </h2>
                <p className="text-sm text-inter text-black">
                  Last password change : {passwordLastChanged}{" "}
                  <span
                    className="text-primary text-sm font-medium py-2 rounded h-9 cursor-pointer underline"
                    onClick={() => navigate("/ChangePassword")}
                    style={{ willChange: "transform" }}
                  >
                    Change Password
                  </span>
                </p>
              </div>

              {/* Button */}
              {/* <button
                className="text-white text-sm font-medium px-4 py-2 rounded h-9 bg-primary hover:scale-105 transition-transform duration-300"
                onClick={() => navigate("/ChangePassword")}
                style={{ willChange: "transform" }}
              >
                Change Password
              </button> */}
            </div>
          </div>

          <div
            className="w-full bg-white rounded-lg border border-[#D9D9D9] mt-4"
            style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
          >
            {/* Section Container */}
            <div className="w-full bg-[#F7F2FF] flex flex-col sm:flex-row sm:items-center justify-between gap-4 px-4 py-4 rounded-lg">
              {/* Text Content */}
              <div className="flex-1">
                <h2 className="text-lg font-semibold text-black font-inter">
                  Delete Account
                </h2>
                <p className="text-sm text-black font-inter">
                  All the data associated with your account will be permanently
                  deleted and cannot be recovered.{" "}
                  <span
                    onClick={toggleModal}
                    className="text-sm font-medium text-primary cursor-pointer underline"
                  >
                    Delete Account
                  </span>
                </p>

                {/* <span
                    onClick={toggleModal}
                    className="text-sm font-medium text-primary cursor-pointer hover:underline"
                  >
                    Delete Account
                  </span> */}
              </div>

              {/* Button */}
              {/* <div className="sm:ml-4 flex-shrink-0 flex justify-end">
                <button
                  className="text-white text-sm font-medium px-6 sm:px-6 py-2 rounded h-9"
                  style={{
                    background:
                      "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                  }}
                  onClick={toggleModal}
                >
                  Delete Account
                </button>
              </div> */}
            </div>
          </div>

          <div
            className="w-full h-[79px] bg-white rounded-lg border border-[#D9D9D9] flex flex-col my-4 mb-10"
            style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
          >
            {/* Single Section */}
            <div className="w-full h-full bg-[#F7F2FF] flex justify-center items-center  rounded-lg">
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault(); // Prevent the default behavior of the Link component
                  openModalWithAnimation(
                    setIsLogoutModalOpen,
                    setLogoutModalAnimation
                  );
                }}
                className="text-[#9061DB] underline text-sm font-medium "
              >
                Log Out
              </Link>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
            <h2 className="text-xl font-bold text-center mb-4">
              Confirm Deletion
            </h2>
            <p className="text-base text-center mb-6">
              Do you want to delete this account?
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-6">
              <button
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-28 text-white"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={handleDeleteAccount}
              >
                Delete
              </button>
              <button
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-28"
                style={{
                  background:
                    "linear-gradient(270deg, #E6E2FF 0%, #D4C6FF 100%)",
                }}
                onClick={toggleModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {isAddressModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg max-h-[90vh] overflow-hidden">
            <div class="flex justify-between  mb-4">
              <span className="text-xl font-bold text-left">Address</span>
              <img
                src={Close_roundClose}
                alt=""
                className="cursor-pointer"
                onClick={toggleAddressModal}
              />
            </div>

            {/* Scrollable Form Section */}
            <div className="overflow-y-auto max-h-[60vh] pr-1">
              <div className="flex flex-col mb-4 text-xs space-y-3">
                <div>
                  <label htmlFor="address">
                    Street<span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="address"
                    placeholder="Street"
                    maxLength={150}
                    className="mt-1 p-2 w-full rounded-lg border border-[#9061DB]"
                    value={address}
                    onChange={(e) => {
                      setAddress(e.target.value);
                      if (e.target.value.trim()) {
                        setErrors((prev) => ({ ...prev, address: "" }));
                      }
                    }}
                  />

                  {errors.address && (
                    <p className="text-red-600 text-xs mt-0">
                      {errors.address}
                    </p>
                  )}
                </div>

                <div>
                  <label htmlFor="postalCode">
                    PIN Code<span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="postalCode"
                    maxLength={10}
                    placeholder="PIN Code"
                    className="mt-1 p-2 w-full rounded-lg border border-[#9061DB]"
                    value={postalCode}
                    onChange={(e) => {
                      const enteredPostalCode = e.target.value;

                      // clear error while typing
                      if (enteredPostalCode.trim()) {
                        setErrors((prev) => ({ ...prev, postalCode: "" }));
                      }

                      if (enteredPostalCode.length === 6) {
                        setPostalCode(enteredPostalCode);
                        handlePostalCodeChange(e);
                      } else {
                        setPostalCode(enteredPostalCode);
                      }
                    }}
                  />
                  {errors.postalCode && (
                    <p className="text-red-600 text-xs mt-0">
                      {errors.postalCode}
                    </p>
                  )}
                </div>

                <div>
                  <label htmlFor="city">City</label>
                  <input
                    type="text"
                    id="city"
                    maxLength={100}
                    placeholder="City"
                    className="mt-1 p-2 w-full rounded-lg border border-[#9061DB]"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                </div>

                <div>
                  <label htmlFor="district">District</label>
                  <input
                    type="text"
                    id="district"
                    placeholder="District"
                    maxLength={50}
                    className="mt-1 p-2 w-full rounded-lg border border-[#9061DB]"
                    value={district}
                    onChange={(e) => setDistrict(e.target.value)}
                  />
                </div>

                <div>
                  <label htmlFor="state">State</label>
                  <input
                    type="text"
                    id="state"
                    placeholder="State"
                    maxLength={50}
                    className="mt-1 p-2 w-full rounded-lg border border-[#9061DB]"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                  />
                </div>

                <div>
                  <label htmlFor="country">Country</label>
                  <input
                    type="text"
                    id="country"
                    placeholder="Country"
                    maxLength={50}
                    className="mt-1 p-2 w-full rounded-lg border border-[#9061DB]"
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                  />
                </div>

                {/* <div>
                  <label htmlFor="gstNo">GST No (optional)</label>
                  <input
                    type="text"
                    id="gstNo"
                    placeholder="GST Number"
                    maxLength={20}
                    className="mt-1 p-2 w-full rounded-lg border border-[#9061DB]"
                    value={gstNo}
                    onChange={(e) => setGstNo(e.target.value)}
                  />
                </div> */}
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="flex flex-col sm:flex-row justify-end items-center gap-4 mt-4">
              <button
                className="text-sm font-medium px-6 py-2 rounded w-full sm:w-24 text-white"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={handleSaveAddress}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {selectedAddress && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-3/5 max-w-lg h-[500px]">
            {/* Header */}
            <div class="flex justify-between mb-4">
              <span className="text-xl font-bold text-left  font-inter">
                Edit Address
              </span>
              <img
                src={Close_roundClose}
                alt=""
                className="cursor-pointer"
                onClick={handleCloseModal}
              />
            </div>

            {/* Scrollable content */}
            <div className="flex flex-col mb-4 overflow-y-auto h-[350px]">
              {/* Address 1 */}
              <label
                htmlFor="address_1"
                className="font-semibold text-gray-800 text-sm"
              >
                Street<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="address_1"
                value={selectedAddress.address_1}
                onChange={(e) =>
                  setSelectedAddress({
                    ...selectedAddress,
                    address_1: e.target.value,
                  })
                }
                className="mb-2 p-2 rounded-lg border border-[#9061DB]"
              />
              {errors.address_1 && (
                <p className="text-red-600 text-xs mt-0">{errors.address_1}</p>
              )}

              {/* City */}
              <label
                htmlFor="city"
                className="font-semibold text-gray-800 text-sm"
              >
                City<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="city"
                value={selectedAddress.city}
                onChange={(e) =>
                  setSelectedAddress({
                    ...selectedAddress,
                    city: e.target.value,
                  })
                }
                className="mb-2 p-2 rounded-lg border border-[#9061DB]"
              />
              {errors.city && (
                <p className="text-red-600 text-xs mt-0">{errors.city}</p>
              )}

              {/* State */}
              <label
                htmlFor="state"
                className="font-semibold text-gray-800 text-sm"
              >
                State<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="state"
                value={selectedAddress.state}
                onChange={(e) =>
                  setSelectedAddress({
                    ...selectedAddress,
                    state: e.target.value,
                  })
                }
                className="mb-2 p-2 rounded-lg border border-[#9061DB]"
              />
              {errors.state && (
                <p className="text-red-600 text-xs mt-0">{errors.state}</p>
              )}

              {/* Pincode */}
              <label
                htmlFor="pincode"
                className="font-semibold text-gray-800 text-sm"
              >
                Pincode<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="pincode"
                value={selectedAddress.pincode}
                onChange={(e) =>
                  setSelectedAddress({
                    ...selectedAddress,
                    pincode: e.target.value,
                  })
                }
                className="mb-2 p-2 rounded-lg border border-[#9061DB]"
              />
              {errors.pincode && (
                <p className="text-red-600 text-xs mt-0">{errors.pincode}</p>
              )}

              {/* District */}
              <label
                htmlFor="district"
                className="font-semibold text-gray-800 text-sm"
              >
                District<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="district"
                value={selectedAddress.district}
                onChange={(e) =>
                  setSelectedAddress({
                    ...selectedAddress,
                    district: e.target.value,
                  })
                }
                className="mb-2 p-2 rounded-lg border border-[#9061DB]"
              />
              {errors.district && (
                <p className="text-red-600 text-xs mt-0">{errors.district}</p>
              )}

              {/* Country */}
              <label
                htmlFor="country"
                className="font-semibold text-gray-800 text-sm"
              >
                Country<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="country"
                value={selectedAddress.country}
                onChange={(e) =>
                  setSelectedAddress({
                    ...selectedAddress,
                    country: e.target.value,
                  })
                }
                className="mb-2 p-2 rounded-lg border border-[#9061DB]"
              />
              {errors.country && (
                <p className="text-red-600 text-xs mt-0">{errors.country}</p>
              )}

              {/* License Number */}
              {/* <label
                htmlFor="license_number"
                className="font-semibold text-gray-800 text-sm"
              >
                GST No (optional)
              </label>
              <input
                type="text"
                id="license_number"
                value={selectedAddress.license_number}
                onChange={(e) =>
                  setSelectedAddress({
                    ...selectedAddress,
                    license_number: e.target.value,
                  })
                }
                className="mb-2 p-2 rounded-lg border border-[#9061DB]"
              /> */}
            </div>

            {/* Modal Buttons */}
            <div className="flex justify-end mt-4">
              <button
                className="text-sm font-medium text-white px-6 py-2 rounded w-24"
                onClick={handleSaveChanges} // Handle saving changes
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {isDeleteConfirmationModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-2/5">
            <h2 className="text-xl font-bold text-center mb-4">
              Confirm Deletion
            </h2>
            <p className="text-lg text-center mb-4">
              Do you want to delete this address?
            </p>
            <div className="flex justify-between">
              <button
                className="text-sm font-medium text-white px-6 py-2 rounded-md w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #E6E2FF 0%, #D4C6FF 100%)",
                }}
                onClick={() => setIsDeleteConfirmationModalOpen(false)} // Close modal
              >
                Cancel
              </button>
              <button
                className="text-sm font-medium text-white px-6 py-2 rounded-md w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={() => handleDeleteConfirmed()} // Confirm deletion
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Postal Location Modal */}
      {showPostalModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg max-h-[90vh] overflow-hidden">
            <h2 className="text-xl font-bold font-inter text-left mb-4">
              Select Your City
            </h2>

            {/* Postal Location List */}
            <div className="space-y-4 overflow-y-auto max-h-[50vh] pr-1">
              {locations.length > 0 ? (
                locations.map((location) => (
                  <div key={location.id} className="flex items-center">
                    <input
                      type="radio"
                      name="postalLocation"
                      value={location.id}
                      checked={selectedLocation?.id === location.id}
                      onChange={() => handleLocationSelection(location)}
                      className="mr-2 accent-[#9061DB]"
                    />
                    <label className="text-sm">{location.postalLocation}</label>
                  </div>
                ))
              ) : (
                <p className="text-sm text-gray-500">
                  No Postal Locations available.
                </p>
              )}
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row justify-end gap-4 mt-6">
              <button
                onClick={handleConfirmLocation}
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-24 text-white"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
              >
                Confirm
              </button>
              <button
                onClick={handleModalClose}
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #E6E2FF 0%, #D4C6FF 100%)",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {isMessageModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-2/5">
            <h2 className="text-xl font-bold text-center mb-4">
              {modalType === "success" ? "Success!" : "Error!"}
            </h2>
            <p className="text-lg text-center mb-4">{modalMessage}</p>
            <div className="flex justify-center">
              <button
                className="bg-gradient-to-r from-[#9061DB] to-[#8777F3] text-white py-2 px-6 rounded-lg"
                onClick={() => setIsMessageModalOpen(false)} // Close modal
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {isEditModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-3/5 max-w-lg overflow-hidden">
            <h2 className="text-xl font-bold text-left mb-4">Edit Address</h2>
            <div className="overflow-y-auto max-h-96">
              <div className="flex flex-col mb-4 text-xs">
                {/* Address Form */}
                <label htmlFor="address">Address</label>
                <input
                  type="text"
                  id="address"
                  placeholder="Street "
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />

                <label htmlFor="postalCode">Postal Code</label>
                <input
                  type="text"
                  id="postalCode"
                  placeholder="Postal Code"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB]"
                  value={postalCode}
                  // onChange={(e) => setPostalCode(e.target.value)}
                  onChange={(e) => {
                    const enteredPostalCode = e.target.value;

                    // Only call handlePostalCodeChange if the length is exactly 6 digits
                    if (enteredPostalCode.length === 6) {
                      setPostalCode(enteredPostalCode); // Update postal code in the state
                      handlePostalCodeChange(e); // Trigger the postal code change handler
                    } else {
                      setPostalCode(enteredPostalCode); // Update the state even if it's not 6 digits yet
                    }
                  }}
                />

                <label htmlFor="city">City</label>
                <input
                  type="text"
                  id="city"
                  placeholder="City"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={city} // Fill city dynamically
                  onChange={(e) => setCity(e.target.value)} // Update city
                />

                <label htmlFor="district">District</label>
                <input
                  type="text"
                  id="district"
                  placeholder="District"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={district} // Fill district dynamically
                  onChange={(e) => setDistrict(e.target.value)} // Update district
                />

                <label htmlFor="state">State</label>
                <input
                  type="text"
                  id="state"
                  placeholder="State"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={state} // Fill state dynamically
                  onChange={(e) => setState(e.target.value)} // Update state
                />

                <label htmlFor="country">Country</label>
                <input
                  type="text"
                  id="country"
                  placeholder="Country"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={country} // Fill country dynamically
                  onChange={(e) => setCountry(e.target.value)} // Update country
                />

                {/* <label htmlFor="gstNo">GST No (optional)</label>
                <input
                  type="text"
                  id="gstNo"
                  placeholder="GST Number"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={gstNo} // Fill GST number dynamically
                  onChange={(e) => setGstNo(e.target.value)} // Update GST number
                /> */}

                {/* Other fields like City, District, State, Country, GST */}
                {/* Repeat for other fields... */}
              </div>
            </div>
            <div className="flex justify-between mt-4">
              <button
                className="text-sm font-medium px-6 py-2 rounded-md w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #E6E2FF 0%, #D4C6FF 100%)",
                }}
                onClick={toggleEditModal} // Close modal
              >
                Cancel
              </button>
              <button
                className="text-sm font-medium px-6 py-2 rounded w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={handleEditAddress}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {isDefaultDeleteModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-2/5">
            <h2 className="text-xl font-bold text-center mb-4 text-[#9061DB]">
              Default Address
            </h2>
            <p className="text-lg text-center mb-4 text-gray-700">
              You cannot delete the default address.
            </p>
            <div className="flex justify-center">
              <button
                className="text-white text-sm font-medium px-6 py-2 rounded-md"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={() => setIsDefaultDeleteModalOpen(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {(isLogoutModalOpen || logoutModalAnimation === "exit") && (
        <div
          className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4 transition-opacity duration-300 ${
            logoutModalAnimation === "enter" ? "opacity-100" : "opacity-0"
          }`}
        >
          <div
            className={`bg-white p-6 rounded-lg shadow-lg w-full max-w-md transform transition-transform duration-300 ${
              logoutModalAnimation === "enter" ? "scale-100" : "scale-95"
            }`}
          >
            <h2 className="text-xl font-bold text-center mb-4">
              Confirm Logout
            </h2>
            <p className="text-base text-center mb-6">
              Are you sure you want to log out?
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-6">
              <button
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-28 text-white"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={handleLogout}
              >
                Logout
              </button>
              <button
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-28"
                style={{
                  background:
                    "linear-gradient(270deg, #E6E2FF 0%, #D4C6FF 100%)",
                }}
                onClick={() =>
                  closeModalWithAnimation(
                    setIsLogoutModalOpen,
                    setLogoutModalAnimation
                  )
                }
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SettingsPage;
